import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/repponlogog6.png'


const _hoisted_1 = { id: "global-header" }
const _hoisted_2 = { class: "nav-menu" }
const _hoisted_3 = ["href"]

import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const titlesArrray = ref([
  {
    title: "首页",
    path: "/",
    titleText: "首页-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "服务介绍",
    path: "/services",
    titleText: "服务介绍-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "关于我们",
    path: "/about",
    titleText: "关于我们-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "联系我们",
    path: "/contact",
    titleText: "联系我们-礼邦物流官网",
    href: "",
    wlink: false,
  },
  {
    title: "客户登录",
    path: "",
    titleText: "",
    // href: "https://ff.jxt56.com/?ff_port_from=555BF0E21CFA01421E66ED7B6E29C902#/base/login/redirect=%2Fbase%2Flogin%",
    href: "https://tat.reppon.com/#/login?id=57",
    wlink: true,
  },
  {
    title: "员工登录",
    path: "",
    titleText: "",
    href: "https://tms.reppon.com/",
    wlink: true,
  },
]);
const activeKey = ref(0);
function selectTitle(titile, index) {
  activeKey.value = index;
  document.querySelector("title").textContent = titile;
}
selectTitle("首页-礼邦物流官网", 0);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        style: {"width":"310px","height":"40px","align-self":"center"},
        src: _imports_0,
        alt: "logo"
      }, null, -1)),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titlesArrray.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            (item.wlink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: item.href,
                  target: "_blank"
                }, _toDisplayString(item.title), 9, _hoisted_3))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  style: _normalizeStyle(
              activeKey.value === index ? { color: 'color: rgb(0 106 233)' } : {}
            ),
                  to: item.path,
                  onClick: ($event: any) => (selectTitle(item.titleText, index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "to", "onClick"]))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})